function unifyList(lista) {
	// Objeto para acumular los totales por nombre
	const acumulador = {};

	// Recorrer la lista y acumular los totales
	lista.forEach(([nombre, total]) => {
		if (acumulador[nombre]) {
			acumulador[nombre] += total;
		} else {
			acumulador[nombre] = total;
		}
	});

	// Convertir el objeto acumulador de vuelta a una lista de listas
	const listaCondensada = Object.entries(acumulador).map(([nombre, total]) => [nombre, total]);

	return listaCondensada;
}

export function formatNumber(value = 0) {
	// Asegurarnos de que value es un número y se formatee a dos decimales
	const number = Number(value).toFixed(4);
    
	// Dividir la parte entera y decimal del número
	const parts = number.split(".");
    
	// Formatear la parte entera con comas como separadores de miles
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
	// Unir la parte entera formateada con la parte decimal usando un punto
	return parts.join(".");
}

export const calculateInvoiceTotal = (items, currency, clientExchangeRate, color, type = 'FACT', isRecurrency = false) => {

	
	const general = {
		base: 0,
		discount: 0,
		baseWithDiscount: 0,
		iva: 0,
		baseNoIVA: 0,
		additionalCosts: [],
		total: 0
	};

	if (!items) return "";

	items.forEach(item => {
		if (item.detailed) {
			// Asegurarse de que cada campo en item.detailed tenga un valor numérico válido
			const detailed = {
				base: Number(item.detailed.base) || 0,
				discount: Number(item.detailed.discount) || 0,
				baseWithDiscount: Number(item.detailed.baseWithDiscount) || 0,
				iva: Number(item.detailed.iva) || 0,
				baseNoIVA: Number(item.detailed.baseNoIVA) || 0,
				additionalCosts: item.detailed.additionalCosts || [],
				total: Number(item.detailed.total) || 0
			};

			general.base += detailed.base;
			general.discount += detailed.discount;
			general.baseWithDiscount += detailed.baseWithDiscount;
			general.iva += detailed.iva;
			general.baseNoIVA += detailed.baseNoIVA;
			general.additionalCosts = general.additionalCosts.concat(detailed.additionalCosts);
			general.total += detailed.total;
		} 
	});

	// Unificar la lista de additionalCosts
	general.additionalCosts = unifyList(general.additionalCosts);

	let calculusHTML = `<p style="margin: 0; text-align: right; color: ${color}">${formatNumber(general.base)}</p>`;

	if (general.discount !== 0) {
		calculusHTML += `
			<p style="margin: 0; text-align: right; color: ${color}">(DESCUENTO) -${formatNumber(general.discount)}</p>
			<span style="display: block; border-top: 1px solid ${color}; margin: 2px 0;"></span>
			<p style="margin: 0; text-align: right; color: ${color}">(BASE) ${formatNumber(general.baseWithDiscount)}</p>
		`;
	}

	if (general.iva !== 0) {
		calculusHTML += `
			<span style="display: block; border-top: 1px solid ${color}; margin: 2px 0;"></span>
			<p style="margin: 0; text-align: right; color: ${color}">${formatNumber(general.baseNoIVA)}</p>
			<p style="margin: 0; text-align: right; color: ${color}">(IVA) +${formatNumber(general.iva)}</p>
		`;
	}

	
	general.additionalCosts.forEach(tax => {
		if (tax[0] !== "IVA" && tax[0] !== "IVA EXENTO") {
			calculusHTML += `<p style="margin: 0; text-align: right; color: ${color}">(${tax[0]})\t+${formatNumber(tax[1])}</p>`;
		}
	});

	let ISR = general.total - general.iva;
	ISR = ISR <= 30000.00 ? ISR * 0.05 : ((ISR - 30000) * 0.05) + 1500;
	
	calculusHTML += `
	<span style="display: block; border-top: 1px solid ${color}; margin: 2px 0;"></span>
	<p style="margin: 0; text-align: right; font-weight:bold; color: ${color}">
	(TOTAL) ${formatNumber(general.total)}</p>
	<span style="display: block; border-top: 1px solid ${color}; margin: 2px 0;"></span>
	<p style="margin: 0; text-align: right; font-weight:bold; color: ${color}">

	${ currency === "USD"?  
		`
			<p style="margin: 0; text-align: right; color: ${color}">(TOTAL EN GTQ) ${isRecurrency && clientExchangeRate == "day"? "N/A" : formatNumber(general.total * (clientExchangeRate ? clientExchangeRate : 1))}</p>
		`
		: `
		
			<p style="margin: 0; text-align: right; color: ${color}">(TOTAL EN USD) ${isRecurrency && clientExchangeRate == "day"? "N/A" : formatNumber(general.total / (clientExchangeRate ? clientExchangeRate : 1))}</p>
		` 
}

	${
		
	type === "FESP" ?
		`
			<span style="display: block; border-top: 1px solid ${color}; margin: 2px 0;"></span>
			<p style="margin: 0; text-align: right; color: ${color}">(Retención IVA) ${formatNumber(general.iva)}</p>
			<p style="margin: 0; text-align: right; color: ${color}">(Retención ISR) ${formatNumber(ISR)}</p>
			<span style="display: block; border-top: 1px solid ${color}; margin: 2px 0;"></span>

			<p style="margin: 0; text-align: right; font-weight:bold; color: ${color}">
			(TOTAL SIN RETENCIONES) ${formatNumber(general.total - general.iva - ISR)}</p>
			<span style="display: block; border-top: 1px solid ${color}; margin: 2px 0;"></span>
			<p style="margin: 0; text-align: right; font-weight:bold; color: ${color}">
		`
		: 
		`
		`
}
	</p>

	`;

	return calculusHTML;
};